"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEADS_DEFAULT_QUESTION_GROUPS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const Questions = require("../../questions/questions");
const answer_1 = require("../../utils/answer");
const group_1 = require("../../utils/group");
const { Question } = Questions;
exports.LEADS_DEFAULT_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "LEADS_DEFAULT_LEGAL_NAME",
        title: "Full legal name",
        id: 136,
        content: [
            Question["First name(s)"].label("PD_1"),
            Question["Last name"].label("PD_2"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "LEADS_DEFAULT_PERSONAL_INFORMATION",
        title: "Personal Information",
        id: 137,
        content: [
            Question["Date of Birth"].label("PD_7"),
            Question["Sex"].label("PD_6"),
            Question["Current country of residence"].label("CR_1"),
            Question["Country of Citizenship"].label("PD_10"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "LEADS_CONTACT_INFORMATION",
        title: "Contact Information",
        id: 138,
        content: [
            Question["Telephone number"].label("CI_22"),
            Question["Email address"].label("PD_23"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "LEADS_IMMIGRATION_STATUS",
        title: "Immigration Status",
        id: 139,
        content: [
            Question["Do you currently have immigration status in Canada?"]
                .label("LEAD_1")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["What is your current immigration status in Canada?"].label("PD_24"),
            ]),
            Question["What are you most interested in applying for in Canada?"].label("LEAD_2"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "LEADS_WORK_EXPERIENCE",
        title: "Work (Employment) History",
        id: 140,
        content: [
            Question["How many years of paid or skilled work experience do you have outside of Canada in the last 10 years?"].label("EMP_5"),
            Question["How many years of paid Canadian work experience do you have in the last 10 years?"].label("EMP_6"),
            Question["What industry is your primary work experience in?"].label("EMP_3"),
            Question["Do you have a job offer from a Canadian company?"].label("EMP_4"),
            Question["Are you a strong French speaker?"].label("LEAD_3"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "LEADS_EDUCATION_HISTORY",
        title: "Education History",
        id: 141,
        content: [
            Question["What is your highest completed level of education?"].label("EDU_49"),
            Question["Did you complete any of your education in Canada?"].label("EDU_50"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "LEADS_COMMENTS_NOTES",
        title: "Notes or comments",
        id: 142,
        content: [
            Question["Do you have any other comments, notes or questions you'd like to tell us about?"].label("LEAD_4"),
        ],
    }),
];
